import { render, staticRenderFns } from "./WebsitePageAgentAssistant.vue?vue&type=template&id=95c63936&scoped=true&"
import script from "./WebsitePageAgentAssistant.vue?vue&type=script&lang=js&"
export * from "./WebsitePageAgentAssistant.vue?vue&type=script&lang=js&"
import style0 from "./WebsitePageAgentAssistant.vue?vue&type=style&index=0&id=95c63936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c63936",
  null
  
)

export default component.exports